import { Avatar, Modal } from 'antd'
import AntdAvatar from 'components/Avatar'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import Date from 'components/Date/Date'
import Drawer from 'components/Drawer'
import Flex from 'components/Flex'
import MultipleCheckBox from 'components/Form/MultipleCheckBox'
import DriveDateIcon from 'components/icons/DriveDateIcon'
import DriveDetailsIcon from 'components/icons/DriveDetailsIcon'
import EditIcon from 'components/icons/EditIcon'
import GroupPeopleIcon from 'components/icons/GroupPeopleIcon'
import StatusIcon from 'components/icons/StatusIcon'
import ApplyFilter from 'modules/Roles/ViewRole/DriveDrawers/DrivesUiComponents/FilterPart/index'
import {
  CollageDetailsFlex,
  SelectClgDiv,
} from 'modules/Roles/ViewRole/DriveDrawers/HostCollegeDrawer/style'
import {
  ShortlistDiv,
  ShortlistFlex,
} from 'modules/Roles/ViewRole/DriveDrawers/PreviewDrawer/style'
import DriveStatus from 'modules/Roles/ViewRole/TwoDriveDrawer/DriveStatus/index'
import {
  CollageNameFlex,
  CollegeCity,
  CollegeNameDiv,
  DreiveDetailFlex,
  DriveDetailsHead,
  DriveDetailsViewDiv,
  DriveInfoStyledFlex,
  DriveNameDiv,
  DriveStatusFlex,
  DriveTypeDiv,
  DriveTypeFlex,
  IconSpan,
  RoleCand,
  RoleNameDiv,
  RolesDiv,
  RolesFlex,
  RolesInfoDiv,
} from 'modules/Roles/ViewRole/TwoDriveDrawer/TwoDriveTable/DriveDetailsDrawe/style'
import {
  UpdateDriveEndDate,
  addCollegeToExistingDrive,
  getAppliedCandidateList,
  getDriveNotCreatedCandidates,
} from 'modules/Roles/actions'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { COLORS } from 'theme'
import { getDay } from 'utils/getDay'
import { getIdFormate } from 'utils/getZeroBeforeInt'
import { roleBasedDegreeListConvertion } from 'utils/roleBasedDegreeListConvertion'
import { EmptySpan } from '../../../../../../components/UIComponents/CommonStyledDiv'

const DriveDetails = ({
  driveDetails,
  setDriveDetails,
  driveData,
  metricsData,
  setTwoDriveDrawer,
}) => {
  const navigate = useNavigate()
  const dispatch = new useDispatch()
  const [shortlistedCandidates, setShortlistedCandidates] = useState({})
  const [loading, setLoading] = useState(false)
  const [applyFilter, setApplyFilter] = useState(false)
  const [studentRating, setStudentRating] = useState('')
  const [minScore, setMinScore] = useState('')
  const [degreeDepartment, setDegreeDepartment] = useState('')
  const [rolesDegreeList, setRolesDegreeList] = useState([])
  const roleBasedDegreeList = useSelector(
    state => state?.corporate?.degreesListBasedOnRoles
  )

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [collegeTableData, setCollegeTableData] = useState({})
  const [selectedInstituteList, setSelectedInstituteList] = useState([])
  const [instituteList, setInstituteList] = useState([])
  const [endDate, setEndDate] = useState('')

  const handleManageDrive = () => {
    navigate(`/drives/${driveData?.id}`)
  }
  useEffect(() => {
    shortlisted()
  }, [
    driveData?.id,
    studentRating,
    minScore,
    degreeDepartment,
    selectedInstituteList,
  ])

  useEffect(() => {
    getNewInstituteList()
  }, [driveData?.id])
  const getNewInstituteList = async () => {
    let { data, status } = await dispatch(
      getDriveNotCreatedCandidates({
        roleId: driveData?.driveRoleMap[0]?.roleId,
        setLoading: setLoading,
        pageLimit: 500,
      })
    )

    if (status >= 200 && status < 300) {
      const compareData = []
      const arr = data?.data?.result || []
      for (const item of arr) {
        if (driveData?.driveMode === 'CAMPUS_DRIVE') {
          if (item?.instituteCampusId === driveData?.hostCollegeId) {
            compareData.push(item)
          }
        } else {
          compareData.push(item)
        }
      }
      setInstituteList(data?.data?.result)

      let b = compareData?.map(data => ({
        label: (
          <CollageDetailsFlex
            spaceBetween
            centerVertically
            style={{ width: '100%' }}
          >
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <Flex alignCenter>
                <AntdAvatar
                  src={data?.campusLogoUrl}
                  size={36}
                  IconName={data?.campusName?.split(' ')[0]?.split('')[0]}
                />

                <CollageNameFlex>
                  <CollegeNameDiv>{data?.campusName}</CollegeNameDiv>
                  <CollegeCity>{data?.campusLocation}</CollegeCity>
                </CollageNameFlex>
              </Flex>
            </div>
            <SelectClgDiv>{data?._count?.id ?? 0}</SelectClgDiv>
          </CollageDetailsFlex>
        ),
        value: data.instituteCampusId,
      }))

      setCollegeTableData(b)
    }
    if (status >= 400) {
      setCollegeTableData({})
      setInstituteList([])
    }
  }
  useEffect(() => {
    const updatedData = roleBasedDegreeListConvertion({
      listOfDegree: roleBasedDegreeList,
      parentNameParam: 'degree',
      parentValueParam: 'degreeId',
      pathName: 'streams',
      childrenValueParam: 'degreeStreamMapId',
    })
    setRolesDegreeList(updatedData)
  }, [roleBasedDegreeList])
  const shortlisted = async () => {
    const outputString = selectedInstituteList?.toString()
    if (selectedInstituteList?.length > 0) {
      let result = await dispatch(
        getAppliedCandidateList({
          roleId: driveData?.driveRoleMap[0]?.roleId,
          setLoading: setLoading,
          searchByRating: studentRating,
          searchByPercentage: minScore,
          searchByDegree: degreeDepartment,
          filterData: {
            collegeName: outputString,
          },
          isListForDriveCreate: '1',
        })
      )

      const { data, status } = result
      if (status >= 200 && status < 300) {
        setShortlistedCandidates(data?.data)
      }
      if (status >= 400) {
        setShortlistedCandidates({})
      }
    } else {
      setShortlistedCandidates({})
    }
  }
  const handleOk = async () => {
    let payload = {
      endDate: endDate,
    }
    const result = await dispatch(UpdateDriveEndDate(driveData?.id, payload))
    if (result?.status >= 200 && result?.status <= 300) {
      setIsModalOpen(false)
      setDriveDetails(false)
      setTwoDriveDrawer(false)
    }
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  const editClick = () => {
    setIsModalOpen(true)
  }
  const handleDateChange = (date, dateString) => {
    if (dateString) setEndDate(moment(date).format('YYYY-MM-DD'))
    else setEndDate('')
  }

  const addToDrive = async () => {
    let localState = {}
    const output = instituteList
      .filter(campus =>
        selectedInstituteList?.includes(campus?.instituteCampusId)
      )
      .map(filteredCampus => ({
        instituteCampusName: filteredCampus?.campusName,
        instituteCampusId: filteredCampus?.instituteCampusId,
      }))

    localState = {
      driveMode: driveData?.driveMode,
      roleId: driveData?.driveRoleMap[0]?.roleId,
      driveId: driveData?.id,
      corporateId: driveData?.corporateId,
      instituteCampusIds: selectedInstituteList,
      colleges: output,
    }
    if (studentRating) {
      localState = { ...localState, studentMinRating: studentRating }
    }
    if (minScore) {
      localState = { ...localState, minScore: minScore }
    }
    if (degreeDepartment?.length) {
      localState = {
        ...localState,
        degreeStreamMapId: degreeDepartment,
      }
    }
    const result = await dispatch(addCollegeToExistingDrive(localState))
    if (result?.status >= 200 && result?.status <= 300) {
      setIsModalOpen(false)
      setDriveDetails(false)
      setTwoDriveDrawer(false)
    }
  }
  const content = () => {
    return (
      <>
        <DriveDetailsHead>
          Drive ID - {getIdFormate(driveData?.serialNo)}
        </DriveDetailsHead>
        <DriveDetailsViewDiv>
          <DreiveDetailFlex>
            <AntdAvatar
              size={36}
              IconName={driveData?.hostCollegeName?.charAt('0')}
            />

            <CollageNameFlex>
              <CollegeNameDiv>{driveData?.hostCollegeName}</CollegeNameDiv>
              <CollegeCity>{driveData?.city}</CollegeCity>
            </CollageNameFlex>
          </DreiveDetailFlex>
          <DriveInfoStyledFlex spaceBetween>
            <DriveTypeFlex
              column
              center
              style={{ flex: 1, paddingLeft: '10px', paddingRight: '10px' }}
            >
              <IconSpan>
                <DriveDetailsIcon />
              </IconSpan>

              <DriveTypeDiv>Drive Type</DriveTypeDiv>
              <DriveNameDiv>
                {driveData?.driveMode?.split('_')?.join(' ')?.toLowerCase()}
              </DriveNameDiv>
            </DriveTypeFlex>
            <DriveTypeFlex
              column
              center
              style={{ flex: 1, paddingLeft: '10px', paddingRight: '10px' }}
            >
              <IconSpan>
                <DriveDateIcon />
              </IconSpan>
              <DriveTypeDiv>Drive Date</DriveTypeDiv>
              <DriveNameDiv>
                {driveData?.startDate
                  ? driveData?.endDate
                    ? `${getDay(driveData?.startDate, true)} - ${getDay(
                        driveData?.endDate,
                        true
                      )}`
                    : getDay(driveData?.startDate, true)
                  : '-'}{' '}
                {driveData?.driveMode !== 'EXP_CANDIDATE_DRIVE' &&
                  driveData?.corporateStatus !== 'CANCELLED' &&
                  driveData?.startDate && (
                    <EmptySpan onClick={editClick}>
                      <Avatar src={<EditIcon />} />
                    </EmptySpan>
                  )}
              </DriveNameDiv>
            </DriveTypeFlex>
            <DriveStatusFlex
              column
              center
              style={{ flex: 1, paddingLeft: '10px', paddingRight: '10px' }}
            >
              <IconSpan>
                <StatusIcon />
              </IconSpan>
              <DriveTypeDiv>Status</DriveTypeDiv>
              <DriveStatus status={driveData?.corporateStatus} />
            </DriveStatusFlex>
          </DriveInfoStyledFlex>
        </DriveDetailsViewDiv>
        <RolesDiv>Roles</RolesDiv>
        <RolesInfoDiv>
          {metricsData?.map((data, index) => (
            <RolesFlex key={index + data?.roleName} spaceBetween>
              <RoleNameDiv>{data?.roleName}</RoleNameDiv>
              <RoleCand>
                {data?.candidateCount}{' '}
                {data?.candidateCount == 1 ? 'Candidate' : 'Candidates'}
              </RoleCand>
            </RolesFlex>
          ))}
        </RolesInfoDiv>
        <br></br>
        {collegeTableData?.length > 0 &&
          driveData?.corporateStatus !== 'CANCELLED' &&
          driveData?.driveMode !== 'EXP_CANDIDATE_DRIVE' && (
            <MultipleCheckBox
              data={collegeTableData}
              setCheckedList={setSelectedInstituteList}
              checkedList={selectedInstituteList}
            />
          )}
        {(shortlistedCandidates?.count > 0 || applyFilter) && (
          <>
            <ShortlistFlex
              background={
                shortlistedCandidates?.count > 0 ? '#eff8f4' : COLORS.RED_T_92
              }
            >
              <GroupPeopleIcon
                color={shortlistedCandidates?.count > 0 ? '#5DB594' : 'red'}
              />
              <ShortlistDiv>
                {`${shortlistedCandidates?.count} New candidate Applied for this Role.`}
              </ShortlistDiv>
            </ShortlistFlex>
            <br></br>

            <ApplyFilter
              applyFilter={applyFilter}
              setApplyFilter={setApplyFilter}
              studentRating={studentRating}
              rolesDegreeList={rolesDegreeList ?? []}
              setStudentRating={setStudentRating}
              minScore={minScore}
              setMinScore={setMinScore}
              degreeDepartment={degreeDepartment}
              setDegreeDepartment={setDegreeDepartment}
              isDisplay={false}
              loading={loading}
            />

            <Flex flexEnd>
              <Button.Primary
                text="Add To Existing Drive"
                disabled={shortlistedCandidates?.count <= 0}
                onClick={addToDrive}
              />
            </Flex>
          </>
        )}
        <Modal
          open={isModalOpen}
          onCancel={handleCancel}
          footer={[
            <div
              style={{ display: 'flex', justifyContent: 'flex-end' }}
              key={isModalOpen + 'footer_array'}
            >
              <Button.Secondary text="Cancel" onClick={handleCancel} />,
              <Button.Primary
                text="Submit"
                onClick={handleOk}
                disabled={endDate === ''}
              />
            </div>,
          ]}
          width={'590px'}
          bodyStyle={{ padding: '20px' }}
        >
          <ShortlistDiv>Change Drive End Date</ShortlistDiv>
          <Control flexStart top="20px" column>
            <Date
              disabledDate={d => !d || d.isBefore(moment())}
              onChange={handleDateChange}
            />
          </Control>
        </Modal>
      </>
    )
  }
  const footer = () => {
    return (
      <Flex flexEnd>
        <Button.Secondary
          width="173px"
          disabled={selectedInstituteList?.length > 0}
          onClick={handleManageDrive}
          text="Go To Manage Drive"
        />
      </Flex>
    )
  }
  return (
    <Drawer
      width="40%"
      title={'Drives Details'}
      placement="right"
      visible={driveDetails}
      content={content()}
      footer={footer()}
      foo
      onClose={() => {
        setDriveDetails(false)
      }}
      closable={true}
    />
  )
}

export default DriveDetails
